import React, { useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';

import { useDispatch } from 'react-redux';
import { ModalWrapper, CloseButton, ModalDescription, Highlight } from './styles';

export function EmailRecoveryModal({ handleClose }) {
  
  const dispatch = useDispatch();
  
  useEffect(() => {
    const handleBeforeUnload = () => {
      dispatch({ type: 'SET_STEP', step: 0 });
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <Modal
      open
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableBackdropClick
    >
      <ModalWrapper>
        <CloseButton onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
        <ModalDescription id="simple-modal-description">
          Para recuperar seu e-mail, contate o SAP Central através dos contatos: <br/><Highlight>4003-0267</Highlight> ou <Highlight>sap@ultragaz.com.br</Highlight>.
        </ModalDescription>
      </ModalWrapper>
    </Modal>
  );
}
